/// <amd-module name="Search/Shared/Base/Sources/SearchSource" />
import * as SearchSharedLegacy from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";
import { SearchQueryResultsTelemetryWriter } from "Search/Shared/Base/Telemetry";
import { IVssPageContext } from "VSS/Platform/Context";
import { EntitySearchResponseWithActivityId } from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";

export interface ISearchSourceResponse {
    responseWithActivityId: EntitySearchResponseWithActivityId | undefined;

    source: SearchSourceType;
}

export enum SearchSourceType {
    DataProvider,

    RestApi
}

/**
 * Extend this class to log telemetry for API calls on search queries.
 */
export class SearchSourceBase<TQuery extends SearchSharedLegacy.EntitySearchQuery> {
    private telemetryWriter: SearchQueryResultsTelemetryWriter;
    constructor(scenarioName: string, entity: string, pageContext: IVssPageContext) {
        this.telemetryWriter = new SearchQueryResultsTelemetryWriter(scenarioName, entity, pageContext);
    }

    /**
     * Issues calls to fetch results for the given query. Also tracks the requests for the purpose of logging telmetry till completion.
     * @param searchQuery
     */
    public getQueryResults(
        searchQuery: TQuery,
        onSuccess: (response: ISearchSourceResponse) => void,
        onFailure: ({ error, activityId }: any) => void): void {
        const requestId = this.telemetryWriter.notifyStarted();
        this.getResults(searchQuery, response => {
            // Being defensive here trying to avoid any NPE if response somehow is undefined.
            if (response) {
                const { responseWithActivityId } = response;
                this.telemetryWriter.notifySucceeded(
                    requestId,
                    {
                        responseActivityId: responseWithActivityId ? responseWithActivityId.activityId[0] : ""
                    });
            }

            onSuccess(response);
        }, failedPayload => {
            this.telemetryWriter.notifyFailed(requestId);
            onFailure(failedPayload);
        });
    }

    /**
     * Child classes need to provide implementation to fetch results for the given query.
     * @param searchQuery
     */
    protected getResults(
        searchQuery: TQuery,
        onSuccess: (response: ISearchSourceResponse) => void,
        onFailure: ({ error, activityId }: any) => void): void {
    }
}
